import './styles/chart-overview.css';
import './styles/date-range.css';

import React from 'react';
import { UserSeatChart } from './charts/user-seats';
import { WorkshopAttendanceChart } from './charts/workshop-attendance';
import { AssignedCompletionsChart } from './charts/assigned-completions';
import { AssignmentsFromWorkflowsChart } from './charts/assignments-from-workflows';
import { AssignmentsOnTimeChart } from './charts/assignments-on-time';
import { WorkflowsTriggeredCalendar } from './charts/workflows-triggered-cal';
import { WorkflowTypesTriggeredChart } from './charts/workflow-types-triggered';
import { WorkflowNamesTriggeredChart } from './charts/workflow-names-triggered';
import { createAuthenticatedClient as createAuthenticatedReportClient } from './utils/api/reports/client';

export default function Layout(props) {
  const reportClient = createAuthenticatedReportClient(
    props.reportBaseUrl,
    props.authToken.authtoken
  );
  let dateLocale = 'en-US';
  if (props.countryLocale === 'australia') {
    dateLocale = 'en-AU';
  }

  return (
    <div>
      <div id="chart-grouping-assignments">
        <div className="chart-grouper-header">Assignments</div>
        <div className="chart-row">
          <div className="chart-container chart-container-height-350">
            <AssignedCompletionsChart reportClient={reportClient} dateLocale={dateLocale} />
          </div>
          <div className="chart-container chart-container-height-350">
            <AssignmentsOnTimeChart reportClient={reportClient} dateLocale={dateLocale} />
          </div>
        </div>

        <div className="chart-row">
          <div className="chart-container chart-container-height-350">
            <AssignmentsFromWorkflowsChart reportClient={reportClient} dateLocale={dateLocale} />
          </div>
        </div>
      </div>

      <div id="chart-grouping-workflows">
        <div className="chart-grouper-header">Workflows</div>
        <div className="chart-row">
          <div className="chart-container chart-container-height-300">
            <WorkflowsTriggeredCalendar reportClient={reportClient} dateLocale={dateLocale} />
          </div>
        </div>

        <div className="chart-row">
          <div className="chart-container chart-container-height-350">
            <WorkflowTypesTriggeredChart reportClient={reportClient} dateLocale={dateLocale} />
          </div>
        </div>

        <div className="chart-row">
          <div className="chart-container chart-container-height-350">
            <WorkflowNamesTriggeredChart reportClient={reportClient} dateLocale={dateLocale} />
          </div>
        </div>
      </div>

      <div id="chart-grouping-general">
        <div className="chart-grouper-header">General</div>
        <div className="chart-row">
          <div className="chart-container chart-container-height-350">
            <UserSeatChart reportClient={reportClient} dateLocale={dateLocale} />
          </div>
          <div className="chart-container chart-container-height-350">
            <WorkshopAttendanceChart reportClient={reportClient} dateLocale={dateLocale} />
          </div>
        </div>
      </div>
    </div>
  );
}
